// import Api from '@/services/Api';
import PythonApi from '@/services/PythonApi';

export default {
  csvDownload(fromDate, toDate, cowIDs, bolusIds, isPh = false) {
    const params = new URLSearchParams();
    if (fromDate) params.append('from_date', fromDate);

    if (toDate) params.append('to_date', toDate);

    if (cowIDs && cowIDs.length)
      cowIDs.forEach(cow_id => params.append('cow_ids', cow_id));

    if (bolusIds && bolusIds.length)
      bolusIds.forEach(bolus_id => params.append('bolus_ids', bolus_id));

    if (isPh) params.append('is_ph', isPh);

    params.append('is_company_timezone', true);

    return PythonApi().get(`sensorLog/download`, params);
  },

  csvPhDownload(fromDate, toDate, cowIDs, bolusIds) {
    return this.csvDownload(fromDate, toDate, cowIDs, bolusIds, true);
  },

  csvDebugDownload(fromDate, toDate, cowIDs, bolusIds) {
    const params = new URLSearchParams();
    if (fromDate) params.append('from_date', fromDate);

    if (toDate) params.append('to_date', toDate);

    if (cowIDs && cowIDs.length)
      cowIDs.forEach(cow_id => params.append('cow_ids', cow_id));

    if (bolusIds && bolusIds.length)
      bolusIds.forEach(bolus_id => params.append('bolus_ids', bolus_id));

    return PythonApi().get(`sensorLog/download-debug`, params);
  },

  csvCowLog(fromDate, toDate, cowIDs) {
    const params = new URLSearchParams();
    if (fromDate) params.append('from_date', fromDate);

    if (toDate) params.append('to_date', toDate);

    params.append('is_company_timezone', true);

    if (cowIDs && cowIDs.length)
      cowIDs.forEach(cow_id => params.append('cow_ids', cow_id));
    return PythonApi().get(`cows/history`, params);
  },

  csvThiDownload(fromDate, toDate) {
    const params = new URLSearchParams();
    if (fromDate) params.append('from_date', fromDate);

    if (toDate) params.append('to_date', toDate);

    return PythonApi().get(`sensorLog/download-thi`, params);
  },

  deleteData(fromDate, toDate, bolusID) {
    const params = new URLSearchParams();
    if (fromDate) params.append('from_date', fromDate);

    if (toDate) params.append('to_date', toDate);

    if (bolusID)
      params.append('bolus_id', bolusID);

    return PythonApi().delete(`sensorLog`, params);
  }
};



// WEBPACK FOOTER //
// ./src/services/SensorLogService.js